(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');

  /** The filter panel collapses on small screens, but must stay open on desktop
      where the disclosure toggle is hidden. */
  function syncFacetsPanel(panel) {
    panel.open = DESKTOP_QUERY.matches || window.location.search.includes('filter.');
  }

  document.querySelectorAll('.facets__panel').forEach((panel) => {
    syncFacetsPanel(panel);
    DESKTOP_QUERY.addEventListener('change', () => syncFacetsPanel(panel));
  });

  document.querySelectorAll('#SortBy').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.form;

      if (form) {
        form.requestSubmit();
      } else {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      }
    });
  });

  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('.price-range__input'));
      this.output = this.querySelector('.price-range__output');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: this.dataset.currency,
        maximumFractionDigits: 0,
      });

      this.inputs.forEach((input) => input.addEventListener('input', () => this.onInput(input)));
      this.closest('form')?.addEventListener('submit', () => this.dropUntouchedBounds());
      this.render();
    }

    /** Keep the price parameters out of the URL while the range covers everything. */
    dropUntouchedBounds() {
      const [min, max] = this.inputs;

      min.disabled = Number(min.value) <= Number(min.min);
      max.disabled = Number(max.value) >= Math.floor(Number(max.max));

      setTimeout(() => {
        min.disabled = false;
        max.disabled = false;
      });
    }

    onInput(input) {
      const [min, max] = this.inputs;

      if (Number(min.value) > Number(max.value)) {
        if (input.dataset.rangeBound === 'min') {
          max.value = min.value;
        } else {
          min.value = max.value;
        }
      }

      this.render();
    }

    render() {
      const [min, max] = this.inputs;
      const bound = Number(max.max) || 1;

      this.style.setProperty('--range-start', `${(Number(min.value) / bound) * 100}%`);
      this.style.setProperty('--range-end', `${(Number(max.value) / bound) * 100}%`);

      if (this.output) {
        this.output.textContent = `${this.formatter.format(min.value)} - ${this.formatter.format(max.value)}`;
      }
    }
  }

  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        this.select(thumb.dataset.galleryThumb);
      });
    }

    select(index) {
      this.querySelectorAll('[data-gallery-slide]').forEach((slide) => {
        slide.classList.toggle('product-gallery__slide--active', slide.dataset.gallerySlide === index);
      });

      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const isActive = thumb.dataset.galleryThumb === index;
        thumb.classList.toggle('product-gallery__thumb--active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
    }
  }

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.field = this.querySelector('input');

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button || !this.field) return;

        const min = Number(this.field.min) || 1;
        const next = (Number(this.field.value) || min) + Number(button.dataset.quantityStep);
        this.field.value = String(Math.max(min, next));
        this.field.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  } catch(e) { console.error(e); }
})();
})();
